import { ExpiredOfflineObjectAsyncTimestampRemover } from '../abstract/expired-offline-object-async-timestamp-remover';
import { ImmoIPTourRouteCheckedChangesObject } from './immo-ip-tour-route-checked-changes-object';

export class ExpiredImmoIPTourRouteCheckedChangesRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ImmoIPTourRouteCheckedChangesObject
> {}
